import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App.jsx";

ReactDOM.render(
  <div>
    <App />
  </div>,
  document.getElementById("root")
);
